import { Labels } from '../../shared-components/global/labels';

Labels.set('ui-table-sortable', 'sortBy', 'Сортировать по');
Labels.set('ui-table-sortable', 'clickToSort', 'Нажмите, чтобы отсортировать');
